export default function handleMentionMeLink(e) {
  e.preventDefault();
  e.stopPropagation();
  console.log('Handling MentionMe Click...');
  const mm_link = $('#mmLink');
  if (mm_link.length) {
    mm_link[0].click();
  }
}
